import {
  IElementsRendererProps,
  RenderElements,
} from "@bond-london/graphcms-rich-text";
import React from "react";

export type PdfRendererProps = IElementsRendererProps &
  Queries.DownloadableAssetFragment;

export const PdfRenderer: React.FC<PdfRendererProps> = (props) => {
  const { localFile, contents } = props;

  if (!localFile?.publicURL) {
    return <pre>No url for pdf</pre>;
  }

  return (
    <a href={localFile.publicURL} className={props.classNameOverrides?.a}>
      {contents?.length ? <RenderElements {...props} /> : localFile.name}
    </a>
  );
};
